/**
 * Responsive layout tokens — single source of truth for all page spacing.
 *
 * Apply these consistently across every view so that the entire app
 * automatically adapts to three viewport tiers:
 *
 *   base (no prefix) — mobile:  0 – 639 px   (sidebar hidden in a drawer)
 *   sm:              — tablet: 640 – 1023 px  (sidebar hidden, wider viewport)
 *   lg:              — desktop: 1024 px +      (sidebar always visible)
 *
 * Tailwind JIT scans this file via the glob in tailwind.config.js
 * (`src/**\/*.{js,ts,jsx,tsx}`), so all class names here are included in
 * the production build automatically.
 */
export const layout = {
  // ── Page-level ────────────────────────────────────────────────────────────

  /**
   * Outer content area padding.
   *   mobile  → p-3  (12 px)
   *   tablet  → p-4  (16 px)
   *   desktop → p-6  (24 px)
   */
  pagePadding: 'p-3 sm:p-4 lg:p-6',

  /**
   * Vertical gap between top-level sections inside a page.
   *   mobile/tablet → space-y-4  (16 px)
   *   desktop       → space-y-6  (24 px)
   */
  pageStack: 'space-y-4 lg:space-y-6',

  // ── Page header ───────────────────────────────────────────────────────────

  /**
   * PageHeader horizontal + vertical padding.
   *   mobile  → px-4  py-3    (16 / 12 px)
   *   tablet  → px-5  py-4    (20 / 16 px)
   *   desktop → px-6  py-5    (24 / 20 px)  ← matches original hardcoded value
   */
  headerPadding: 'px-4 py-3 sm:px-5 sm:py-4 lg:px-6 lg:py-5',

  // ── Card & grid ───────────────────────────────────────────────────────────

  /**
   * Gap between sibling cards inside a grid.
   *   mobile  → gap-2.5  (10 px)
   *   tablet  → gap-3    (12 px)
   *   desktop → gap-4    (16 px)  ← matches original hardcoded value
   */
  cardGap: 'gap-2.5 sm:gap-3 lg:gap-4',

  /**
   * Inner padding for Card / MetricCard components.
   *   mobile  → p-3  (12 px)
   *   sm+     → p-4  (16 px)  ← matches original hardcoded value
   */
  cardPad: 'p-3 sm:p-4',
} as const
